import { merchantKnowledgeArticleSchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import { merchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

export const getKnowledgeArticle = {
  name: "getKnowledgeArticle" as const,
  input: z.object({ id: merchantKnowledgeIdFormat.schema }),
  output: merchantKnowledgeArticleSchema,
};
